import React, { Component } from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import _ from "lodash"
import shop from "shop/shop"
import moment from "moment"
import Responsive from "react-responsive"

import Price from "components/Price/Price"
import { fetchExtraOrderRessources } from "theme/arnoldsports/pages/AccountPage";

import { Button, Label, Modal, Pagination, Table, Icon, Loader } from "semantic-ui-react";
//import OrderModel from "../shop/OrderModel";


class AccountOrderDetailPage extends Component {
  state = {
    order: false,
    orderId: false,
    openRechnung: false,
    openLieferschein: false,
    openAuftrag: false,
    open: false
  }


  constructor(props) {
    super()
    console.log(`new order page`, props, { orderId: props.match.params.orderId })
    if (props && props.match.params && props.match.params.orderId) {
      this.loadOrder(props.match.params.orderId)
      this.setState({ orderId: props.match.params.orderId })
    }
  }

  async loadOrder(orderId) {
    const order = await this.getSelectedOrder(orderId)

    this.setState({ order })
  }

  render() {
    const { order } = this.state
    const { backOrderMode } = this.props.match.params
    const { open, openRechnung, openAuftrag, openLieferschein } = this.state
    var counterLieferschein = 0
    var counterRechnung = 0
    var counterAuftrag = 0
    if (!order) return (
      <div>
        <Loader active />
      </div>
    )

    console.log({ order })

    return (

      <div className="container pt4 pb5">

        <div className="pb3"><Button as={Link} size={"small"} basic to="/account">{translate("zurück zum Konto")}</Button></div>
        <h1>
          {backOrderMode && <div>{translate("Rückstände")} #{order.map_id}</div>}
          {!backOrderMode && <div>{translate("Bestellung")} #{order.map_id}</div>}
        </h1>

        {backOrderMode && <div>
          <Link className={"underline"} to={`/account/orders/${order.map_id}`}>{translate("Alle Positionen anzeigen")}</Link>
        </div>}

        {/*order.extrainfo && <React.Fragment>
          <h3 className="mt4">{translate( "Dokumente" )}</h3>
          <div className="flex flex-row items-center">
            {_.sortBy( order.extrainfo, "type" ).map( ( pdf, index ) => {
              return <a href={pdf.url} download={pdf.map_id} key={pdf.map_id} className="pa4 bg-white mr3 w-100 mw5 box-shadow relative">
                <div className="pt4">
                  <div className="f7">{pdf.content}</div>
                  <div className="f3 text-bold ttu">{translate( `${pdf.typeName}` )}</div>
                </div>
                <div className="pointer-events-none absolute black-10 right-1 top-1 f1 m-auto flex flex-col items-center justify-center text-bold">
                  <div>PDF</div>
                </div>
              </a>
            } )}
          </div>
        </React.Fragment>*/}

        {order.extrainfo && order.extrainfo.length > 0 && shop.session.value.map_price_cond != '3605' && shop.session.value.map_price_cond != '3610' && shop.session.handId != '1' && <React.Fragment>
          <h3 className="mt4">{translate("Dokumente")}</h3>
          <div className="row-title title--left"> </div>
          <table className="w-100 bb b--black-20 w-100">
            <colgroup>
              <col width="50%" />
              <col width="50%" />
            </colgroup>
            <thead>
              <tr className="bb b--black-20 w-100">
                <th className="tl f5 pb3">{translate("Rechnung")}</th>
                <th className="tl f5 pb3">{translate("Lieferschein")}</th>
              </tr>
            </thead>
            <tbody>
              <td className="pt2">
                {order.extrainfo.map((answer, i) => {
                  if (answer.content && answer.content.includes("VKSF")) {
                    return <div className="w-100 pb2"><Button size={"tiny"} basic onClick={() => this.setState({ openRechnung: true })}>{translate("Rechnung herunterladen")}</Button></div>
                  }
                })}
                <Modal
                  closeIcon={<Icon name="close" />}
                  open={openRechnung}
                  style={{ top: '20%' }}
                  onClose={() => {
                    this.setState({ openRechnung: false })
                  }}
                  size="tiny">

                  <Modal.Header style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                    {translate("Rechnung herunterladen")}</Modal.Header>
                  <Modal.Content
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                    {order.extrainfo.map((answer, i) => {

                      if (answer.content && answer.content.includes("VKSF")) {

                        counterRechnung++
                        console.log("answer", answer)
                        return (<div colSpan="1" key={answer} answer={answer}>
                          <a href={`${answer.url}`} download={`${translate('Rechnung')}.pdf`}><Button size={"tiny"} basic >{counterRechnung + ". " + translate("Rechnung herunterladen")}<br /> {answer.content}</Button></a><br /><br /></div>)
                      }
                    })}
                  </Modal.Content>
                </Modal>
              </td>
              <td className="pt2">
                {order.extrainfo.map((answer, i) => {

                  if (answer.content && answer.content.includes("VKLS")) {
                    return <div className="w-100 pb2"><Button size={"tiny"} basic onClick={() => this.setState({ openLieferschein: true })}>{translate("Lieferschein herunterladen")}</Button></div>
                  }
                })}
                <Modal
                  closeIcon={<Icon name="close" />}
                  open={openLieferschein}
                  onClose={() => {
                    this.setState({ openLieferschein: false })
                  }}
                  size="tiny">

                  <Modal.Header style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                    {translate("Lieferschein herunterladen")}</Modal.Header>
                  <Modal.Content
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                    {order.extrainfo.map((answer, i) => {

                      if (answer.content && answer.content.includes("VKLS")) {
                        console.log("ANSWER: ", answer)
                        counterLieferschein = counterLieferschein + 1
                        return (<div colSpan="1" key={answer} answer={answer}>
                          <a href={`${answer.url}`} download={`${translate('Lieferschein')}.pdf`}><Button size={"tiny"} basic >{counterLieferschein + ". " + translate("Lieferschein herunterladen")}<br /> {answer.content}</Button></a><br /><br /></div>)
                      }
                    })}
                  </Modal.Content>
                </Modal>
              </td>
            </tbody>
          </table>
        </React.Fragment>}

        <h3 className="mt4">{translate("cart.positions")}</h3>
        <div className="row-title title--left"> </div>
        <div className="pb3">
          <OrderDetailTable order={order} filterBackorders={!!backOrderMode} products={order.positions} netto={order.netto} />
        </div>
        <p>
          <span className="ttu b">{translate("shop.comment")}: </span>
          {order.comment ? order.comment : "-"}
        </p>

        <p>
          <span className="ttu b">{translate("Erstellt am")}: </span>
          {moment(order.created)
            .format("DD.MM.YYYY")}
        </p>

      </div>
    )
  }

  getSelectedOrder(orderId) {
    return shop.fetch("/shop/rest/data/orders?start=0&count=120&open=0")
      .then(res => res.values)
      .then(orders => {
        let order = orders.filter(o => o.map_id == orderId)
        return _.first(order)
      })
      .then(order => fetchExtraOrderRessources(order))
  }
}

const OrderDetailTable = ({ products, netto, order, filterBackorders }) => {
  const filteredProducts = filterBackorders ? products.filter(p => p.open !== 0) : products
  //console.log("ORDERDETAILTABLE:", products)
  //console.log("nettobackorder: ", order)
  return (
    <div className="table-scroller">
      <Responsive minWidth={670}>
        <table className="w-100">
          <colgroup>
            <col width="15%" />
            <col width="40%" />
            <col width="10%" />
            <col width="6%" />
            <col width="10%" />
            <col width="12%" />
            <col width="7%" />
          </colgroup>
          <thead>
            <tr className="bb b--black-20 w-100">
              <th className="f5 pb3 tl">{translate("product.articlenr")}</th>
              <th className="f5 pb3 tl">{translate("product.label")}</th>
              <th className="f5 pb3 tl">{translate("Stück")}</th>
              <th className="f5 pb3 tl">{translate("VE")}</th>
              <th className="f5 pb3 tr">{translate("Stückpreis")}</th>
              <th className="f5 pb3 tr">{translate("Summe")}</th>
              <th className="f5 pb3 tr"></th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts && filteredProducts.map((product, index) => <OrderDetailRow key={index + "_" + product.map_id} product={product} />)}
            <tr className="bt b--black-20">
              <td className="tr" colSpan="1">
                <span className="">{translate("Zwischensumme")}</span>
              </td>
              <td className="tr" colSpan="5">
                <span className="tr ttu f3 pv3 db b"><Price>{netto}</Price></span>
              </td>
            </tr>
            {order.nettoBackorder != 0 && <tr>
              <td className="tr" colSpan="1">
                <span className="">{translate("offen")}</span>
              </td>
              <td className="tr" colSpan="5">
                <span className="tr ttu f3 pv3 db b"><Price>{order.nettoBackorder}</Price></span>
              </td>
            </tr>}
          </tbody>
        </table>
      </Responsive>
      <Responsive maxWidth={669}>
        <table className="w-100">
          <colgroup>
            <col width="15%" />
            <col width="50%" />
            <col width="20%" />
            <col width="15%" />
          </colgroup>
          <thead>
            <tr className="bb b--black-20 w-100">
              <th className="f5 pb3 tl">{translate("product.articlenr")}</th>
              <th className="f5 pb3 tl">{translate("product.label")}</th>
              <th className="f5 pb3 tr">{translate("Summe")}</th>
              <th className="f5 pb3 tr"></th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts && filteredProducts.map((product, index) => <OrderDetailRow key={index + "_" + product.map_id} product={product} />)}
            <tr className="bt b--black-20">
              <td className="tr" colSpan="1">
                <span className="">{translate("Zwischensumme")}</span>
              </td>
              <td className="tr" colSpan="2">
                <span className="tr ttu f3 pv3 db b"><Price>{netto}</Price></span>
              </td>
            </tr>
            {order.nettoBackorder != 0 && <tr>
              <td className="tr" colSpan="1">
                <span className="">{translate("offen")}</span>
              </td>
              <td className="tr" colSpan="5">
                <span className="tr ttu f3 pv3 db b"><Price>{order.nettoBackorder}</Price></span>
              </td>
            </tr>}
          </tbody>
        </table>
      </Responsive>

    </div>
  )
}

OrderDetailTable.propTypes = {
  products: PropTypes.array,
}


const OrderExtraDetailTable = ({ order }) => {
  var counterLieferschein = 0
  var counterRechnung = 0
  var counterAuftrag = 0
  return (

    {/*<div className="table-scroller">
      <Table>
        <colgroup>
          <col width="33%"/>
          <col width="33%"/>
          <col width="33%"/>
        </colgroup>
        
        <Table.Header>
          <tr>
            <th className="tc">{translate( "Rechnung" )}</th>
            <th className="tc">{translate( "Lieferschein" )}</th>
            <th className="tc">{translate( "Auftrag" )}</th>
          </tr>
        </Table.Header>
        
        <Table.Body>
        <tr>
        <td className="tc">        {order.extrainfo.map((answer, r) => {     
           if(answer.content && answer.content.includes("VKSF")){
            counterRechnung = counterRechnung +1
            return (<div key={answer} answer={answer}><Button 
              size={"tiny"} basic onClick={() => { 
       }}>{counterRechnung + translate( ". Rechnung" )}</Button><br/><br/></div>)
           }
        })}</td>
          <td className="tc">        {order.extrainfo.map((answer, i) => {     
           
           if(answer.content && answer.content.includes("VKLS")){
            
            counterLieferschein = counterLieferschein+1
            return (<div colSpan="1" key={answer} answer={answer}><Button 
              size={"tiny"} basic onClick={() => {
       }}>{counterLieferschein + translate( ". Lieferschein" )}</Button><br/><br/></div>)
           }
        })}</td>
        <td className="tc">        {order.extrainfo.map((answer, a) => {     
             
           if(answer.content && answer.content.includes("VKLS")){
            counterAuftrag++
            return (<div colSpan="1" key={answer} answer={answer}><Button 
              size={"tiny"} basic onClick={() => {
       }}>{counterAuftrag + translate( ". Auftrag" )}</Button><br/><br/></div>)
           }
        })}</td>
          </tr>
        </Table.Body>
      </Table>
      </div>*/}
  )
}

OrderExtraDetailTable.propTypes = {
  products: PropTypes.array,
}

const OrderDetailRow = ({ product }) => {

  return (
    <React.Fragment>
      <Responsive minWidth={670}>
        <tr className={`${product.open !== 0 && "isOpenPosition"}` + " bt b--black-20"}>
          <td><a href={`/product/${product.article_id}`} key={product.article_id} className="db mt3 mb3 pt1 pb1 block text-gray-900 shadow-sm hover:shadow-lg transition-all">{product.article_nr}</a></td>
          <td>
            <div>{product.desc}</div>
            {/*<div className={""}>
            {product.open !== 0 && <div className={"blue"}>{translate( "Rückstand" )} <span className={"b blue"}>{product.open} </span></div>}
          </div>*/}
          </td>
          <td className="tl">{product.count} {translate("Stück")}</td>
          <td className="tl" title={product.unit_multi}>{Math.round(product.unit_multi)}</td>
          <td className="tr">
            <div><Price>{product.price}</Price></div>
          </td>
          <td className="tr">
            <div><Price>{product.sum}</Price></div>
            {/*product.open > 0 && <div><span className="black-70 f7">{translate( "offen" )}</span> <Price>{product.open * product.price}</Price></div>*/}
          </td>
          <td className="tr"><Button icon={"shopping cart"} onClick={async () => {
            const p = await shop.product(product.article_id)
            if (p) {
              p.count = 1
              shop.cart.add(p)
              shop.toast(translate("Produkt hinzugefügt"), "success", false, "bottom")
            } else {
              shop.toast(translate("Produkt nicht mehr verfügbar"), "info", false, "bottom")
            }
          }} /></td>
        </tr>
      </Responsive>
      <Responsive maxWidth={669}>
        <tr className={`${product.open !== 0 && "isOpenPosition"}` + " bt b--black-20"}>
          <td>
            <a href={`/product/${product.article_id}`} key={product.article_id} className="db mt3 mb3 pt1 pb1 block text-gray-900 shadow-sm hover:shadow-lg transition-all">{product.article_nr}</a>
            <div className="nowrap">
              <b>{translate("Preis")}:</b> <Price>{product.price}</Price>
            </div>
          </td>
          <td>
            <div className="flex items-center" style={{ height: "52px" }}>
              <div className="overflow-hidden" style={{ height: "38px" }}>{product.desc}</div>
            </div>
            <div><b>{translate("Stück")}:</b> {product.count}</div>
          </td>
          <td className="tr">
            <div className="flex items-center justify-end" style={{ height: "52px" }}><Price>{product.sum}</Price></div>
            <div><b>{translate("VE")}:</b> {Math.round(product.unit_multi)}</div>
          </td>
          <td className="tr"><Button icon={"shopping cart"} onClick={async () => {
            const p = await shop.product(product.article_id)
            if (p) {
              p.count = 1
              shop.cart.add(p)
              shop.toast(translate("Produkt hinzugefügt"), "success", false, "bottom")
            } else {
              shop.toast(translate("Produkt nicht mehr verfügbar"), "info", false, "bottom")
            }
          }} /></td>
        </tr>
      </Responsive>
    </React.Fragment>
  )
}

OrderDetailTable.propTypes = {
  product: PropTypes.object,
}

export default (AccountOrderDetailPage)



// WEBPACK FOOTER //
// ./src/theme/mags/pages/AccountOrderDetailPage.js